/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
  HTTPValidationError,
  HTTPValidationErrorFromJSON,
  HTTPValidationErrorToJSON,
  ListOrdersResponse,
  ListOrdersResponseFromJSON,
  ListOrdersResponseToJSON,
  OrderReportResponse,
  OrderReportResponseFromJSON,
  OrderReportResponseToJSON,
  SingleOrderResponse,
  SingleOrderResponseFromJSON,
  SingleOrderResponseToJSON,
} from '../models';

export interface ExportOrderReportOrdersReportIdGetRequest {
  id: number;
  acceptLanguage?: string;
}

export interface GetSingleOrderOrdersIdGetRequest {
  id: number;
  acceptLanguage?: string;
}

export interface ListOrdersOrdersGetRequest {
  page?: number;
  perPage?: number;
  createdAt?: Date;
}

/**
 *
 */
export class OrdersApi extends runtime.BaseAPI {
  /**
   *    This endpoint is used to export single order as an excel file for the current Channel.     It first checks from the existing of the order or channel id,     if one of them deosn\'t exist an Execption Error will be raised.     Otherwise, it will retrun a link of excel file has the following columns:    - Date : Datetime as 2xxx-xx-xx    - GiftCardName: str    - GiftCardVariant: str    - Code: str    - Pin: str    - Price: float    - ExpiryDate : Datetime as 2xxx-xx-xx    - VAT : Int     it has the following path parameters:    - **id**: order id, it is required.     and the following header parameters:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English)
   * Export Order Report
   */
  async exportOrderReportOrdersReportIdGetRaw(
    requestParameters: ExportOrderReportOrdersReportIdGetRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<OrderReportResponse>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling exportOrderReportOrdersReportIdGet.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/orders/report/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OrderReportResponseFromJSON(jsonValue)
    );
  }

  /**
   *    This endpoint is used to export single order as an excel file for the current Channel.     It first checks from the existing of the order or channel id,     if one of them deosn\'t exist an Execption Error will be raised.     Otherwise, it will retrun a link of excel file has the following columns:    - Date : Datetime as 2xxx-xx-xx    - GiftCardName: str    - GiftCardVariant: str    - Code: str    - Pin: str    - Price: float    - ExpiryDate : Datetime as 2xxx-xx-xx    - VAT : Int     it has the following path parameters:    - **id**: order id, it is required.     and the following header parameters:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English)
   * Export Order Report
   */
  async exportOrderReportOrdersReportIdGet(
    requestParameters: ExportOrderReportOrdersReportIdGetRequest,
    initOverrides?: RequestInit
  ): Promise<OrderReportResponse> {
    const response = await this.exportOrderReportOrdersReportIdGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    This endpoint is used to show single order for the current Channel.     It first checks from the existing the order and channel id,     if one of them doesn\'t exist an Exception Error will be raised.     Otherwise, it will return a list of :    - id as the order id of type int    - vat_rate as the vat rate applied on the order. e.g. 0.15    - vat as the tax amount after applying tax on taxable items.    - subtotal as the total amount with no tax included of type float.    - total as a total price of type float    - created_at as created_at of type datetime    - cards as items of type cartItem     it has the following path parameter:    - **id**: order id, it is required.     and the following header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English)
   * Get Single Order
   */
  async getSingleOrderOrdersIdGetRaw(
    requestParameters: GetSingleOrderOrdersIdGetRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<SingleOrderResponse>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling getSingleOrderOrdersIdGet.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/orders/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SingleOrderResponseFromJSON(jsonValue)
    );
  }

  /**
   *    This endpoint is used to show single order for the current Channel.     It first checks from the existing the order and channel id,     if one of them doesn\'t exist an Exception Error will be raised.     Otherwise, it will return a list of :    - id as the order id of type int    - vat_rate as the vat rate applied on the order. e.g. 0.15    - vat as the tax amount after applying tax on taxable items.    - subtotal as the total amount with no tax included of type float.    - total as a total price of type float    - created_at as created_at of type datetime    - cards as items of type cartItem     it has the following path parameter:    - **id**: order id, it is required.     and the following header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English)
   * Get Single Order
   */
  async getSingleOrderOrdersIdGet(
    requestParameters: GetSingleOrderOrdersIdGetRequest,
    initOverrides?: RequestInit
  ): Promise<SingleOrderResponse> {
    const response = await this.getSingleOrderOrdersIdGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    This endpoint is used to list all orders of the current Channel.     it returns all orders of the current Channel.     as a list of :    - id: order id    - created_at: the time order created at    - vat_rate: the vat rate applied on the order. e.g. 0.15    - vat: as the tax amount after applying tax on taxable items.    - subtotal: as the total amount with no tax included of type float.    - total: as a total price of type float    - source: \"STORE\" or \"API\" of type str     This endpoint has the following query parameters:    - **page**: number of the page,  optional to be set.    - **per_page**: how many orders will be shown per page, optional to be set.    - **created_at**: optional to be set, it is used for filtration purposes,    it will return the orders according to the created_at value.
   * List Orders
   */
  async listOrdersOrdersGetRaw(
    requestParameters: ListOrdersOrdersGetRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<ListOrdersResponse>> {
    const queryParameters: any = {};

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page;
    }

    if (requestParameters.perPage !== undefined) {
      queryParameters['per_page'] = requestParameters.perPage;
    }

    if (requestParameters.createdAt !== undefined) {
      queryParameters['created_at'] = (
        requestParameters.createdAt as any
      ).toISOString();
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/orders/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ListOrdersResponseFromJSON(jsonValue)
    );
  }

  /**
   *    This endpoint is used to list all orders of the current Channel.     it returns all orders of the current Channel.     as a list of :    - id: order id    - created_at: the time order created at    - vat_rate: the vat rate applied on the order. e.g. 0.15    - vat: as the tax amount after applying tax on taxable items.    - subtotal: as the total amount with no tax included of type float.    - total: as a total price of type float    - source: \"STORE\" or \"API\" of type str     This endpoint has the following query parameters:    - **page**: number of the page,  optional to be set.    - **per_page**: how many orders will be shown per page, optional to be set.    - **created_at**: optional to be set, it is used for filtration purposes,    it will return the orders according to the created_at value.
   * List Orders
   */
  async listOrdersOrdersGet(
    requestParameters: ListOrdersOrdersGetRequest,
    initOverrides?: RequestInit
  ): Promise<ListOrdersResponse> {
    const response = await this.listOrdersOrdersGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
}
